<template>
  <div class="template-status noWrap">
    <v-icon
      :color="getStatus.color"
    >
      mdi-checkbox-blank-circle
    </v-icon>
    <span>
      {{ getStatus.label }}
    </span>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: [Boolean, Number],
      required: true,
    },
  },
  data: () => ({
    name: 'TemplatesStatusColumn',
    templateStatus: {
      1: {
        color: '#3FD65F',
        textColor: 'success',
        label: 'Ativo',
      },
      2: {
        color: '#F15F5F',
        textColor: 'error',
        label: 'Inativo',
      },
    },
  }),
  computed: {
    getStatus() {
      if (this.value === true) {
        return this.overrideSuccess(this.templateStatus[1]);
      }
      if (this.value === false) {
        return this.overrideError(this.templateStatus[2]);
      }
      return this.templateStatus[this.value];
    },
  },
  methods: {
    overrideSuccess(status = {}) {
      return {
        ...status,
      };
    },
    overrideError(status = {}) {
      return {
        ...status,
      };
    },
  },
};
</script>

<style scoped>

.template-status > .v-icon {
    font-size: 0.8em;
    margin-right: 8px;
    margin-top: -0.2em;
}

.template-status span {
  margin-top: 5px;
}

</style>
